import { createSelector } from 'reselect';

import { getAssignmentHashKey } from '@components/status-cell/helpers';

import { getAssignments, getSortedStudentIds, getStudents } from '@helpers/selectors/common';

export const filterNeedAttentionStudentsSelector = learningJourneyId =>
  createSelector([getAssignments, getStudents, getSortedStudentIds], (assignments, students, studentIds) => {
    const filteredStudentIds = studentIds.filter(studentId => {
      const assignmentHashKey = getAssignmentHashKey(studentId, learningJourneyId);
      const assignment = assignments[assignmentHashKey];

      return !!assignment?.studentNeedsAttention;
    });

    return filteredStudentIds.map(id => students[id]);
  });

export default filterNeedAttentionStudentsSelector;



// WEBPACK FOOTER //
// ./components/learning-journey/selectors.js